import { fitToSize, sizeOptionsOrDefault } from './utils';
import { Rectangle } from './Rectangle';
const defaultOptions = {
    ellipseRxRatio: 0.5,
    ellipseRyRatio: 0.13,
    bottomEdgeYRatio: 0.76
};
/**
 * Represents an Off-Page Connector shape, a flowchart element used to indicate
 * continuation of a flowchart on another page. Extends Rectangle with a custom
 * pentagon-like path with rounded top edge.
 */
export class OffPageConnector extends Rectangle {
    /**
     * Creates a new OffPageConnector instance.
     * @param options - Configuration options for the off-page connector shape
     */
    constructor(options) {
        super({ ...defaultOptions, ...options });
    }
    /**
     * @hidden
     * Draws the off-page connector shape path as a pentagon with rounded top.
     */
    _drawPath() {
        const drawingElement = this.drawingElement;
        const { width, height } = sizeOptionsOrDefault(this.options);
        const strokeWidth = this.options.stroke.width || 0;
        const ellipseRX = width * this.options.ellipseRxRatio;
        const ellipseRY = height * this.options.ellipseRyRatio;
        const topY = ellipseRY;
        const leftY = topY;
        const rightY = topY;
        const bottomY = height * this.options.bottomEdgeYRatio;
        const bottomMiddleX = width / 2;
        const bottomMiddleY = height;
        drawingElement
            .moveTo([0, topY])
            .arcTo([width, rightY], ellipseRX, ellipseRY, false, false)
            .lineTo([width, bottomY])
            .lineTo([bottomMiddleX, bottomMiddleY])
            .lineTo([0, bottomY])
            .lineTo([0, leftY])
            .close();
        fitToSize(this.drawingElement, width, height, strokeWidth);
    }
}
